import apiService from '../api';

// Unauthenticated endpoints reached via a token in the URL rather than a
// login session — see server/controllers/publicSurveysController.js.
const surveyApiPublicMixin = {
  async getPublicSurveyByToken(token) {
    return apiService.request(`/public-surveys/respond/${token}`);
  },

  async submitPublicSurveyResponses(token, responses) {
    return apiService.request(`/public-surveys/respond/${token}/responses`, {
      method: 'POST',
      body: JSON.stringify({ responses })
    });
  },

  /** Non-identifying preview (title/course) for the "log in to continue" class-link landing page. */
  async getSurveyClassLinkPreview(token) {
    return apiService.request(`/public-surveys/class/${token}`);
  },
};

export default surveyApiPublicMixin;
